import { render, staticRenderFns } from "./cander.vue?vue&type=template&id=563708de&scoped=true"
import script from "./cander.vue?vue&type=script&lang=js"
export * from "./cander.vue?vue&type=script&lang=js"
import style0 from "./cander.vue?vue&type=style&index=0&id=563708de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563708de",
  null
  
)

export default component.exports